export default "__VITE_ASSET__DsxT9MB1__"